require("jquery-ui/ui/widgets/autocomplete.js");

function PropertyAutoComplete() {
    var propertyid = $("#PropertyId").val();

    $(function () { });

    $("#propertySearch").autocomplete({
        minLength: 3,
        source: function (request, response) {
            $.ajax({
                url: "Summary/propertySearch",
                type: "POST",
                dataType: "json",
                data: { propertySearch: request.term },
                success: function (data) {
                    $("#PropertyId").val('0');
                    response($.map(data, function (item) {
                        return { label: item.name, value: item.propertyId };
                    }))
                }
            })
        },
        select: function (event, ui) {
            $("#PropertyId").val(ui.item.value);
            $("#propertySearch").val(ui.item.label);
            PopulateLocationDropdown(ui.item.value);
            return false;
        }
    });

    $("#toggleFilterPanel").click(function () {
        $("#filterPanel").toggle(800, function () {
        });
    });

    const toggleFilterPanelBtn = document.querySelectorAll('#toggleFilterPanel');
    if (toggleFilterPanelBtn.length) {
        toggleFilterPanelBtn.forEach(el => el.addEventListener('click', event => {
            el.querySelector('i:last-child').classList.toggle('fa-rotate-180');
        }));
    }
}

$("#resetFilterButton").click(function () {
    $("#PropertyId").val('');
    $("#propertySearch").text('');
    $("#PriorityID").val('');
    $("#TypeID").val('');
    $("#FilterFromDate").val('');
    $("#FilterToDate").val('');
});

function PopulateLocationDropdown(propId, locId) {
    $.ajax({
        type: "GET",
        url: "WorkOrder/LocationFilter",
        data: { propertyId: propId },
        success: function (data) {
            var s = '<option value="0">Please Select a Location</option>';
            for (var i = 0; i < data.length; i++) {
                s += '<option value="' + data[i].id + '">' + data[i].path + '</option>';
            }
            $("#locationsDropdown").html(s);
            if (locId != 0 && locId != "") {
                $('#locationsDropdown option[value="' + locId + '"]').attr("selected", "selected");
            }
        }
    });
}

$(function () {
    flatpickr("#FilterFromDate", {});
});

module.exports = { PropertyAutoComplete, PopulateLocationDropdown };